module.exports = __webpack_public_path__ + "static/media/design2.3fc42ec6.jpg";